var _module_exports = "<div data-ng-include=\" '/app/common/partials/header.html' \" class=\"app-header navbar\"></div><div data-ng-include=\" '/app/vendor/ec-fe-bo-template/dist/views/partials/aside.html' \" class=\"app-aside hidden-xs {{app.settings.asideColor}}\"></div><div class=\"app-content\"><div ui-butterbar data-qa=\"loadingBar\"></div><a href class=\"off-screen-toggle hide\" ui-toggle-class=\"off-screen\" data-target=\".app-aside\"></a><div class=\"app-content-body\" ui-view></div></div>\n";;
var path = '/app/vendor/ec-fe-bo-template/dist/views/base/template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/vendor/ec-fe-bo-template/dist/views/base/template.html
// module id = 917
// module chunks = 0